import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Client',
    returnTo: 'Clients'
  }),
  created() {
    this.$store.dispatch('culture/getItems');
    this.$store.dispatch('country/getItems');
    this.$store.dispatch('vatType/getItems');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData,
    vatNumberIsRequired(vatTypeID) {
      const vatType = this.$store.getters['vatType/getLoadedItemByID'](vatTypeID);
      return !!(vatType && vatType.vatNumberRequiredYN);
    }
  }
};
